
app.pagesController = app.pagesController || {};
app.pagesController.defaultAction = {

    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    homeAction : function () {
        $('.homeBigSlider').slick({
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            dots: false,
        });

        $('.lastNewsSlider').slick({
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            fade: true,
        });
    },

    histoireAction : function () {

        var wpp = document.location.origin+'/content/themes/moulinvert/img/frise/';
        var cache = [];

        preloadImages('1902b.jpg','1906b.jpg','1908b.jpg','1911b.jpg','1911bis-b.jpg','1925b.jpg','1931b.jpg','1941b.jpg','1942b.jpg','1947b.jpg','1947bis-b.jpg','1965b.jpg','1986b.jpg','2006b.jpg');


        function preloadImages() {
            var args_len = arguments.length;
            for (var i = args_len; i--;) {
                var cacheImage = document.createElement('img');
                cacheImage.src = wpp + arguments[i];
                cache.push(cacheImage);
            }
        }

        function startFrise() {
            $('#boutonFrise').fadeOut();
            var newBG = wpp + "un-siecle-d-innovations-sociales-frise.jpg";
            $('#friseContainer').attr('height', '300px');
            $('#friseContainer').animate({
                height: 450,
                opacity: 0
            }, 1000, function () {
                $('#makeMeScrollable').show();
                $('#makeMeScrollable').smoothDivScroll({
                    mousewheelScrolling: "allDirections",
                    manualContinuousScrolling: true,
                    autoScrollingMode: "onStart",
                    autoScroll: "onStart",
                    autoScrollDirection: "right",
                    autoScrollStep: 1,
                    autoScrollInterval: 75,
                    visibleHotSpots: "always"
                });
                $('#friseContainer').css('background-image', 'url(' + newBG + ')');
                $('#friseContainer').animate({
                    opacity: 100
                }, 5000);
            });
        }

        function initFrise() {
            $('#makeMeScrollable').hide();
            $('#ajaxLoad').hide();
            $('#friseContainer').css('background-image', 'url(' + wpp + 'un-siecle-d-innovations-sociales.jpg)');
            $('#boutonFrise').show();
            $('#boutonFrise').mouseover(function () {
                    $('#boutonFrise').attr('src', wpp + 'boutonFriseHover.png');
                }
            );
            $('#boutonFrise').mouseout(function () {
                    $('#boutonFrise').attr('src', wpp + 'boutonFrise.png');
                }
            );
            $('#boutonFrise').click(function () {
                    startFrise();
                }
            );
        }
        initFrise();
    },

    recrutementAction : function () {
        $dropdown = $('[class^="sf-field-taxonomy-"]');
        $dropdown.children('h4').on('click', function(e){
            $button = $(e.target);
            $this_dropdown = $button.parent('[class^="sf-field-taxonomy-"]');
            $list = $button.next('ul');
            $dropdown.not($this_dropdown).removeClass('is-active');
            $this_dropdown.toggleClass('is-active');
        });
        $('body').on('click', function(e){
            $target = $(e.target);
            $activeDropdown = $('[class^="sf-field-taxonomy-"].is-active');
            if ($activeDropdown.length > 0) {
                if ( $target.parents('[class^="sf-field-taxonomy-"]').length === 0 || $target.is('[class^="sf-field-taxonomy-"]') ) {
                    $activeDropdown.removeClass('is-active');
                }
            }
        });
    },

    postulerAction : function () {

        var $_GET = {};

        document.location.search.replace(/\??(?:([^=]+)=([^&]*)&?)/g, function () {
            function decode(s) {
                return decodeURIComponent(s.split("+").join(" "));
            }

            $_GET[decode(arguments[1])] = decode(arguments[2]);
        });

        $('.fld-offers select option[value=' + $_GET.offer_id + ']').attr('selected', 'selected');
        $('select').trigger('render');
    },

    candidatureAction : function () {
        var $selectCheck = $('.selectCheck');
        $('body').on(app.clickEvent, function(e) {
            $target = $(e.target);
            //console.log($target.parents('.selectCheck').length);
            if ($target.parents('.selectCheck').length < 1) {
                $selectCheck.removeClass('is-active');
            }
            else {
                $target.parent('.selectCheck').siblings().removeClass('is-active');
                $target.parent('.selectCheck').toggleClass('is-active');
            }
        });

        $(".wpcf7").on('wpcf7:submit', function(event){

            var errorMsg = $('<span class="error wpcf7-not-valid-tip">Veuillez cocher au moins 1 établissement.</span>');

            if ($('#fld-etabl [type="checkbox"]:checked').length < 1) {
                $('#fld-etabl').parents('.selectCheck').find('.fldCustom').addClass('aria-invalid');
                $('#fld-etabl').parents('.selectCheck').append(errorMsg);
            } else {
                $('#fld-etabl').parents('.selectCheck').find('.fldCustom').removeClass('aria-invalid');
            }
        });
    },
};

$(document).ready(function(){

    // Home page
    if ($('body').hasClass('home')) {
        app.pagesController.defaultAction.homeAction();
    }
    // Page Notre histoire
    if ($('body').hasClass('notre-histoire')) {
        app.pagesController.defaultAction.histoireAction();
    }
    // Page Recrutement
    if ($('body').hasClass('recrutement')) {
        app.pagesController.defaultAction.recrutementAction();
    }
    if ($('body').hasClass('candidature-spontanee')) {
        app.pagesController.defaultAction.candidatureAction();
    }
    if ($('body').hasClass('postuler')) {
        app.pagesController.defaultAction.postulerAction();
    }
});
